import React from "react";
import { Styled } from './styled';
import Quote from "~/components/quote";
import {SellMoreScreen} from "~common/sell-more-screen";

const AutoCall = () => {
  return (
    <>
      <Styled.Container>
        <Styled.Title>
          Автоперезвон
        </Styled.Title>
        <Styled.Text>
          Модуль Автоперезвон автоматически соединит свободного сотрудника с недозвонившимся абонентом. Вы можете установить скорость перезвона на пропущенный вызов и количество попыток.
          <Styled.Indent />
          Вот что говорят наши клиенты, использующие автоперезвон:
        </Styled.Text>
        <Styled.BlockQuote>
          <Quote width='800'>
            <Styled.TextBold>Игорь, владелец магазина детских игрушек</Styled.TextBold>
            <Styled.Indent/>
            <Styled.TextComment>Конкуренция среди онлайн-магазинов — настоящая битва, плюс мы работаем только с входящими звонками. Поэтому если клиент не дозвонился с первого раза, то он просто купит товар в другом месте.</Styled.TextComment>
            <Styled.Indent/>
            <Styled.TextComment>Быстро обрабатывать заказы нам больше всего помогает автоперезвон по пропущенным. Благодаря ему, менеджеры не откладывают пропущенные на конец дня, а перезванивают клиенту в кратчайшие сроки.</Styled.TextComment>
            <Styled.Indent/>
            <Styled.TextComment>Клиенты не успевают уйти к конкурентам, а поскольку продукция у нас правда отличная, то клиенты возвращаются за повторными покупками.</Styled.TextComment>
          </Quote>
        </Styled.BlockQuote>
      </Styled.Container>
      <Styled.SelMore className="onlinepbx__sel__more">
        <SellMoreScreen />
      </Styled.SelMore>
    </>
  )
}

export default AutoCall
